// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f5952f0e","703":"3aa10079","880":"7414a38a"}[chunkId] + ".chunk.js";
};